/*添加服务*/
define('services/mysetting/mod.bussiness.service',['app', 'mainCons'], function (app, mainCons) {
    return app.factory('modBussService', ['$q', 'ngDialog', '$filter', '$state', 'auiDialog', 'OpenUp', 'auiAgreementHelper', 'serviceresource', 'UserInfo','tenantsService',
        function ($q, ngDialog, $filter, $state, auiDialog, OpenUp, auiAgreementHelper, serviceresource, UserInfo,tenantsService) {

            var countryList = [];
            var userType = '';

            function getBussinesInfo(queryRangeFlag, callback) {
                UserInfo.getMerchantContactList().then(function () {
                    UserInfo.getTaxInfo().then(function () {
                        UserInfo.promise().then(function (res) {
                            userType = res.userType;
                            var bussiness = {};
                            if (res) {
                                OpenUp.getControllerList({req:{}}).then(function (data) {
                                    bussiness.developerInfo = res;
                                    //获取联系人信息
                                    bussiness.contactInfo = res.contactInfo;
                                    bussiness.userTaxInfo = res.userTaxInfo;
                                    bussiness.indivDeveloper = res;
                                    bussiness.corpDeveloper = res;
                                    bussiness.userID = res.id;
                                    if (data && data.controllerList) bussiness.controllerList = data.controllerList;
                                    var leftMenuList = serviceresource.menu.getLeftMenu();
                                    if (hasAuthority("MerchantService", leftMenuList)) {
                                        getMerchantInfo(function (bankInfo) {
                                            if (bankInfo.bankInfoCN) {
                                                bussiness.bankInfoCN = bankInfo.bankInfoCN;
                                            }
                                            if (bankInfo.bankInfoEN) {
                                                bussiness.bankInfoEN = bankInfo.bankInfoEN;
                                            }
                                            if(bankInfo.developerAttachment) {
                                                bussiness.developerAttachment = bankInfo.developerAttachment;
                                            }
                                            callback(bussiness);
                                        });
                                    } else {
                                        callback(bussiness);
                                    }
                                })


                            }
                        })
                    })
                })

            }


            var ret = false;

            //判断是否具有itemName 权限
            function hasAuthority(itemCode, leftMenuList) {


                for (var i = 0; i < leftMenuList.length; i++) {
                    if (leftMenuList[i].resourceTree && leftMenuList[i].resourceTree.length > 0) {
                        hasAuthority(itemCode, leftMenuList[i].resourceTree);
                    } else {
                        if (leftMenuList[i].itemCode == itemCode) {
                            ret = true;
                        }
                    }
                }

                return ret;
            }

            function getBussinesInfoMsg(latestUserInfo) {
                var defer = $q.defer();
                var bussiness = latestUserInfo;
                var leftMenuList = serviceresource.menu.getLeftMenu();
                if (hasAuthority("MerchantService", leftMenuList)) {
                    //用于纳税人类型校验和银行帐号校验
                    OpenUp.getMerchantInfo({
                        req: {
                            bankType: 2,
                            queryRangeFlag: '1'
                        }
                    }).then(function (data) {
                        if (data && data.developerBanks && data.developerBanks.length > 0) {
                            for (var i = 0; i < data.developerBanks.length; i++) {
                                var developerBank = data.developerBanks[i];
                                if (developerBank.bankType == 0) {
                                    bussiness.bankInfoCN = developerBank;
                                } else if (developerBank.bankType == 1) {
                                    bussiness.bankInfoEN = developerBank;
                                }
                            }
                            bussiness.petalPayCertifyStatus = data.petalPayCertifyStatus;
                        }
                        defer.resolve(bussiness);
                    });
                } else {
                    defer.resolve(bussiness);
                }

                return defer.promise;
            }


            function getNotifyMessage(callback) {
                OpenUp.getNotifyMessage({
                    "req": {displayPosition: 2}
                }).then(function (res) {
                    if (res && res.resultCode === 0) {
                        callback(res.message);
                    }
                });
            }

            function getCurrencyConfig(params) {
                var defer = $q.defer();
                OpenUp.getCurrencyConfig(params).then(function (res) {
                    if (res && res.resultCode === 0) {
                        defer.resolve(res.currencyConfigs);
                    } else {
                        defer.reject();
                    }
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }

            function getMerchantInfo(callback) {
                var bussiness = {};
                //0：本币银行，1：跨国支付银行，2：所有银行
                //每位取值：1：查询  0：不查询，
                OpenUp.getMerchantInfo({
                    req: {
                        bankType: 2,
                        queryRangeFlag: '1'
                    }
                }).then(function (data) {
                    if (data && data.developerBanks && data.developerBanks.length > 0) {
                        for (var i = 0; i < data.developerBanks.length; i++) {
                            var developerBank = data.developerBanks[i];
                            if (developerBank && developerBank.bankType == 0) {
                                bussiness.bankInfoCN = angular.fromJson(developerBank);
                            } else if (developerBank && developerBank.bankType == 1) {
                                bussiness.bankInfoEN = angular.fromJson(developerBank);
                            }
                        }
                    }
                    if(data.developerAttachment && JSON.stringify(data.developerAttachment) !== '{}') {
                        bussiness.developerAttachment = data.developerAttachment
                    }
                    callback(bussiness);
                });
            }

            function getPayVerifyBank() {
                var defer = $q.defer();
                var bankInfoCN = {};
                OpenUp.getLatestPayVerifyBank({req: {}}).then(function (data) {
                    if (data) {
                        var payVerifyBankInfo = data.payVerifyBankInfo;
                        if (payVerifyBankInfo) {
                            bankInfoCN = angular.fromJson(payVerifyBankInfo);
                            bankInfoCN.hProvince = bankInfoCN.province;
                            bankInfoCN.hCity = bankInfoCN.city;
                            bankInfoCN.hAddr = bankInfoCN.branchName;
                            bankInfoCN.currency = 'CNY';
                        }
                    }
                    defer.resolve(bankInfoCN);
                });
                return defer.promise;
            }

            function getExtAttr() {
                var defer = $q.defer();
                OpenUp.getExtAttr({req: {name: 'bankWhitelistStatus'}}).then(function (data) {
                    if (data && data.value == 1) {
                        defer.resolve(1);
                    } else {
                        //0表示不支持离岸
                        defer.resolve(0);
                    }
                }).catch(function () {
                    //0表示不支持离岸
                    defer.resolve(0);
                });
                return defer.promise;
            }

            function getMerchantCountryList() {
                var defer = $q.defer();
                if (countryList && countryList.length > 0) {
                    defer.resolve(countryList);
                } else {
                    OpenUp.getMerchantCountryList({req: {language: 'zh_CN'}}).then(function (data) {
                        if (data && data.countryList) {
                            data.countryList.sort(AUI.BaseJSUtil.arrObjCompare('normalName'));
                            data.countryList.forEach(function (country) {
                                countryList.push({key: country.alpha2Code, value: country.normalName})
                            });
                        }
                        defer.resolve(countryList);
                    });
                }
                return defer.promise;
            }

            //判断是否签署过商户协议
            function getIsSignAgreement(Model) {
                var defer = $q.defer();
                var agreements = [Model.agreements.merchantServiceAgree.agreeType];
                    agreements.push(Model.agreements.petalsTremServiceAgree.agreeType);
                    agreements.push(Model.agreements.petalsServiceAgree.agreeType);
                auiAgreementHelper.queryAgreements(agreements).then(function (signInfo) {
                    if (signInfo && signInfo.signInfoList && signInfo.signInfoList.length > 0) {
                        var signInfoList = signInfo.signInfoList;
                        var agreementToTemplateInfos = [];
                        for (var i in signInfoList) {
                            if (signInfoList[i].signStatus == 1 || signInfoList[i].signStatus == 2) {// 签署状态。1：已签署最新版本；2：已签署非最新版本；3：未签署；
                                if (signInfoList[i].agrType == Model.agreements.merchantServiceAgree.agreeType) {
                                    Model.agreements.merchantServiceAgree.isSignedAgree = true;
                                }
                                if (signInfoList[i].agrType == Model.agreements.petalsTremServiceAgree.agreeType) {
                                    Model.agreements.petalsTremServiceAgree.isSignedAgree = true;
                                }
                                if (signInfoList[i].agrType == Model.agreements.petalsServiceAgree.agreeType) {
                                    Model.agreements.petalsServiceAgree.isSignedAgree = true;
                                }
                            } else {
                                if (signInfoList[i].agrType == Model.agreements.merchantServiceAgree.agreeType) {
                                    Model.agreements.merchantServiceAgree.isSignedAgree = false;
                                }
                                if (signInfoList[i].agrType == Model.agreements.petalsTremServiceAgree.agreeType) {
                                    Model.agreements.petalsTremServiceAgree.isSignedAgree = false;
                                }
                                if (signInfoList[i].agrType == Model.agreements.petalsServiceAgree.agreeType) {
                                    Model.agreements.petalsServiceAgree.isSignedAgree = false;
                                }
                                agreementToTemplateInfos.push({
                                    agrType: signInfoList[i].agrType,
                                    latestVersion: signInfoList[i].latestVersion
                                });
                            }
                        }
                        Model.showAgreementFlag = true
                        if (agreementToTemplateInfos.length > 0) {
                            queryAgreeTemplate(Model, agreementToTemplateInfos).then(function () {
                                defer.resolve();
                            });
                        } else {
                            defer.resolve();
                        }
                    } else {
                        defer.resolve();
                        auiDialog.failSystemError();
                    }
                });
                return defer.promise;
            }

            //查询协议的url
            function queryAgreeTemplate(Model, agreementToTemplateInfos) {
                var defer = $q.defer();
                auiAgreementHelper.agreementToTemplateInfo(agreementToTemplateInfos).then(function (templateInfoListResult) {
                    if (templateInfoListResult && templateInfoListResult.templateInfoList && templateInfoListResult.templateInfoList.length > 0) {
                        for (var i in templateInfoListResult.templateInfoList) {
                            if (templateInfoListResult.templateInfoList[i].agrType == Model.agreements.merchantServiceAgree.agreeType) {
                                Model.agreements.merchantServiceAgree.leastMerchantServiceAgree = angular.copy(templateInfoListResult.templateInfoList[i]);
                                Model.agreements.merchantServiceAgree.notSignAgreeUrl = templateInfoListResult.templateInfoList[i].url;
                            }
                            if (templateInfoListResult.templateInfoList[i].agrType == Model.agreements.petalsTremServiceAgree.agreeType) {
                                Model.agreements.petalsTremServiceAgree.leastMerchantServiceAgree = templateInfoListResult.templateInfoList[i];
                                Model.agreements.petalsTremServiceAgree.notSignAgreeUrl = templateInfoListResult.templateInfoList[i].url;
                            }
                            if (templateInfoListResult.templateInfoList[i].agrType == Model.agreements.petalsServiceAgree.agreeType) {
                                Model.agreements.petalsServiceAgree.leastMerchantServiceAgree = templateInfoListResult.templateInfoList[i];
                                Model.agreements.petalsServiceAgree.notSignAgreeUrl = templateInfoListResult.templateInfoList[i].url;
                            }
                        }
                        defer.resolve();
                    } else {
                        defer.reject();
                    }
                });
                return defer.promise;
            }

            //签署单个协议 flag 判断是否需要签署
            function signSingleAgreement(Model, agrTypeIdentity, flag) {
                var defer = $q.defer();
                if (!flag) {
                    defer.resolve(true);
                }
                //如果是没有同意的
                else if ((!Model.merchantServiceIsSelected && agrTypeIdentity == 'merchantServiceAgree') || (Model.agreements[agrTypeIdentity].isSignedAgree)) {
                    defer.resolve(true);
                } else {
                    var merchantServiceAgreeParm = {
                        agrType: Model.agreements[agrTypeIdentity].leastMerchantServiceAgree.agrType,
                        version: Model.agreements[agrTypeIdentity].leastMerchantServiceAgree.version,
                        language: Model.agreements[agrTypeIdentity].leastMerchantServiceAgree.language
                    };
                    //签署隐私协议
                    auiAgreementHelper.signAgreement(merchantServiceAgreeParm).then(function (res) {
                        //查询最新的版本号
                        if (res) {
                            defer.resolve(res);
                        } else {
                            defer.reject();
                        }
                    }).catch(function () {
                        defer.reject();
                    });
                }
                return defer.promise;
            }

            function changeContract(old, newC) {
                var changed = false;
                if (newC.coorperation && (old.coorperation && old.coorperation.key != newC.coorperation.key || !old.coorperation && newC.coorperation.key)) {
                    changed = true;
                } else if (newC.legal && (old.legal && old.legal.key != newC.legal.key || !old.legal && newC.legal.key)) {
                    changed = true;
                } else if (newC.finance && (old.finance && old.finance.key != newC.finance.key || !old.finance && newC.finance.key)) {
                    changed = true;
                } else if (newC.market && (old.market && old.market.key != newC.market.key || !old.market && newC.market.key)) {
                    changed = true;
                }
                return changed;
            }

            function changeTax(old, newC) {
                var changed = false;
                //改变税号
                if (newC.taxNum && old.taxNum != newC.taxNum || !newC.taxNum && old.taxNum) {
                    changed = true;
                } else if (newC.registerAddress && old.registerAddress != newC.registerAddress || !newC.registerAddress && old.registerAddress) {
                    changed = true;
                } else if (newC.taxReceiptType && (old.taxReceiptType && old.taxReceiptType.value != newC.taxReceiptType.value || !old.taxReceiptType && newC.taxReceiptType.value)) {
                    changed = true;
                }
                //改变税务的城市
                else if (newC.city && (old.city && old.city.value != newC.city.value || !old.city && newC.city.value)) {
                    changed = true;
                } else if (newC.province && (old.province && old.province.value != newC.province.value || !old.province && newC.province.value)) {
                    changed = true;
                }
                return changed;
            }

            //离岸银行是否改变
            function changeBankInfoOffSite(Model, oldBankInfoEN) {
                var changed = false;
                if (oldBankInfoEN.country && oldBankInfoEN.country.value != Model.bankInfoEN.country.value || !oldBankInfoEN.country && Model.bankInfoEN.country.value) {
                    changed = true;
                } else if (Model.bankInfoEN.bank && (oldBankInfoEN.bank && oldBankInfoEN.bank.value != Model.bankInfoEN.bank.value || !oldBankInfoEN.bank && Model.bankInfoEN.bank.value)) {
                    changed = true;
                } else if (Model.bankInfoEN.branch && (oldBankInfoEN.branch && oldBankInfoEN.branch.value != Model.bankInfoEN.branch.value || !oldBankInfoEN.branch && Model.bankInfoEN.branch.value)) {
                    changed = true;
                } else if (oldBankInfoEN.accountName != Model.bankInfoEN.accountName) {
                    changed = true;
                }
                //离岸银行新增
                else if (oldBankInfoEN.bankNumber && oldBankInfoEN.bankNumber != Model.bankInfoEN.bankNumber || !oldBankInfoEN.branchNumber && Model.bankInfoEN.bankNumber) {
                    changed = true;
                } else if (oldBankInfoEN.branchNumber && oldBankInfoEN.branchNumber != Model.bankInfoEN.branchNumber || !oldBankInfoEN.branchNumber && Model.bankInfoEN.branchNumber) {
                    changed = true;
                } else if (oldBankInfoEN.hCity && oldBankInfoEN.hCity != Model.bankInfoEN.hCity || !oldBankInfoEN.hCity && Model.bankInfoEN.hCity) {
                    changed = true;
                } else if (oldBankInfoEN.branchAddress && oldBankInfoEN.branchAddress != Model.bankInfoEN.branchAddress || !oldBankInfoEN.branchAddress && Model.bankInfoEN.branchAddress) {
                    changed = true;
                } else if (oldBankInfoEN.swiftCode && oldBankInfoEN.swiftCode != Model.bankInfoEN.swiftCode || !oldBankInfoEN.swiftCode && Model.bankInfoEN.swiftCode) {
                    changed = true;
                } else if (oldBankInfoEN.iban && oldBankInfoEN.iban != Model.bankInfoEN.iban || !oldBankInfoEN.iban && Model.bankInfoEN.iban) {
                    changed = true;
                } else if (oldBankInfoEN.bankAccount && oldBankInfoEN.bankAccount != Model.bankInfoEN.bankAccount && Model.bankInfoEN.bankAccount != Model.bankInfoEN.bankAccountFuzzy || !oldBankInfoEN.bankAccount && Model.bankInfoEN.bankAccount) {
                    changed = true;
                } else if (oldBankInfoEN.attribute4 && oldBankInfoEN.attribute4 != Model.bankInfoEN.attribute4 || !oldBankInfoEN.attribute4 && Model.bankInfoEN.attribute4) {
                    changed = true;
                } else if (oldBankInfoEN.accountType && oldBankInfoEN.accountType != Model.bankInfoEN.accountType || !oldBankInfoEN.accountType && Model.bankInfoEN.accountType) {
                    changed = true;
                } else if (oldBankInfoEN.kc && oldBankInfoEN.kc != Model.bankInfoEN.kc || !oldBankInfoEN.kc && Model.bankInfoEN.kc) {
                    changed = true;
                } else if (oldBankInfoEN.taxPayerId && oldBankInfoEN.taxPayerId != Model.bankInfoEN.taxPayerId || !oldBankInfoEN.taxPayerId && Model.bankInfoEN.taxPayerId) {
                    changed = true;
                }
                return changed;
            }

            function changeBankInfoEN(Model, old, newBk) {
                var changed = false;
                // 如果新值跟原值不一样，则亮化提交按钮
                if (old.country && old.country.value != newBk.country.value || !old.country && newBk.country.value) {
                    changed = true;
                } else if (old.currency && old.currency != newBk.currency || !old.currency && newBk.currency || old.accountCurrencys != newBk.accountCurrencys) {
                    changed = true;
                } else if (old.bankAccount && old.bankAccount != newBk.bankAccount && newBk.bankAccount != newBk.bankAccountFuzzy || !old.bankAccount && newBk.bankAccount) {
                    changed = true;
                } else if (old.accountName && old.accountName != newBk.accountName || !old.accountName && newBk.accountName) {
                    changed = true;
                } else if (newBk.bank && (old.bank && old.bank.value && old.bank.value != newBk.bank.value || (!old.bank || !old.bank.value) && newBk.bank.value)) {
                    changed = true;
                } else if (newBk.branch && (old.branch && old.branch.value && old.branch.value != newBk.branch.value || (!old.branch || !old.branch.value) && newBk.branch.value)) {
                    changed = true;
                } else if (old.acctNameAttachment != Model.acctNameAttachmentEN) {
                    changed = true;
                }
                return changed;
            }

            function changeBankInfoCN(Model, old, newBk) {
                var changed = false;
                // 如果新值跟原值不一样，则亮化提交按钮
                if (old.country && old.country.value != newBk.country.value || !old.country && newBk.country.value) {
                    changed = true;
                } else if (newBk.bank && (old.bank && old.bank.value != newBk.bank.value || !old.bank && newBk.bank.value)) {
                    changed = true;
                } else if (newBk.province && (old.province && old.province.value != newBk.province.value || !old.province && newBk.province.value)) {
                    changed = true;
                } else if (newBk.city && (old.city && old.city.value != newBk.city.value || !old.city && newBk.city.value)) {
                    changed = true;
                } else if (old.accountName != newBk.accountName) {
                    changed = true;
                } else if (old.bankAccount != newBk.bankAccount && newBk.bankAccount != newBk.bankAccountFuzzy) {
                    changed = true;
                } else if (old.acctNameAttachment != Model.acctNameAttachmentCN) {
                    changed = true;
                } else if (old.branch.value != newBk.branch.value) {
                    changed = true;
                } else if (newBk.legalManVideoUrl && old.legalManVideoUrl && old.legalManVideoUrl != newBk.legalManVideoUrl || !old.legalManVideoUrl && newBk.legalManVideoUrl) {
                    changed = true;
                }
                return changed;
            }

            function initSetContactInfo(contactInfo, Model, contactorType) {
                contactInfo.forEach(function (v) {
                    if (v.contactMeta) {
                        for (var i = 0; i < contactorType.length; i++) {
                            if (v.role == contactorType[i]) {
                                Model.contactorInfo[contactorType[i]] = {
                                    key: v.contactMeta.contactID,
                                    value: v.contactMeta.familyName + v.contactMeta.givenName
                                };
                                break;
                            }
                        }
                    }
                });
            }

            function getDefaultCountrysList() {
                return [
                    {
                        key: 'USD',
                        value: 'USD'
                    },
                    {
                        key: 'EUR',
                        value: 'EUR'
                    }
                    ,
                    {
                        key: 'HKD',
                        value: 'HKD'
                    }
                    ,
                    {
                        key: 'JPY',
                        value: 'JPY'
                    }
                    ,
                    {
                        key: 'CHF',
                        value: 'CHF'
                    }
                    ,
                    {
                        key: 'GBP',
                        value: 'GBP'
                    }
                ]
            }

            function beforeSubmitBankInfo(Model, $scope, oldBankInfoCN, oldBankInfoEN) {
                var contact = {};
                var contactList;
                if (Model.contactorInfo && Model.contactorInfo.market) {
                    contact.market = Model.contactorInfo.market.key
                }
                if (Model.contactorInfo && Model.contactorInfo.finance) {
                    contact.finance = Model.contactorInfo.finance.key
                }
                if (Model.contactorInfo && Model.contactorInfo.legal) {
                    contact.legal = Model.contactorInfo.legal.key
                }
                if (Model.contactorInfo && Model.contactorInfo.coorperation) {
                    contact.coorperation = Model.contactorInfo.coorperation.key
                }
                if (Model.contactorInfo && (Model.contactorInfo.market || Model.contactorInfo.finance || Model.contactorInfo.legal || Model.contactorInfo.coorperation)) {
                     contactList = JSON.stringify(contact);
                }
                //在加拿大的税务信息
                var CountryTaxItems =[];
                var canadaTaxNumber  = [];
                Model.TaxItem.forEach(function (item,i){
                    if(item.termsIsSelected && item.taxName != 'NA'){
                        canadaTaxNumber.push({
                            taxClassCode:'CA00' + (i+1),
                            taxNumber:Model.newTaxItem[i].taxNum
                        })
                    }else if(item.termsIsSelected && item.taxName == 'NA'){
                        canadaTaxNumber.push({
                            taxClassCode:'NA',
                            taxNumber:''
                        })
                    }
                })
                if(Model.otherTaxsIncluded == 2){
                    CountryTaxItems.push({
                        taxCountry:'CA',
                        taxItems:canadaTaxNumber
                    })
                }else {
                    CountryTaxItems = null;
                }
                var userTaxInfo = {
                    taxProvinceName: Model.taxInfo.province.key,
                    taxCityName: Model.taxInfo.city.key,
                    taxNum: Model.taxInfo.taxNum,
                    taxType: Model.taxInfo.taxType + '',
                    registerAddress: Model.taxInfo.registerAddress,
                    taxReceiptType: Model.taxInfo.taxReceiptType.key,
                    taxCountry: 'CN',
                    taxOrgCategory:1,
                };
                if(Model.isCheckedBankEN){
                    userTaxInfo.deliveryCountryTaxItems = CountryTaxItems;
                    userTaxInfo.otherTaxsIncluded = Model.otherTaxsIncluded;
                }
                var controllerInfo = {
                    addControllerList: [],
                    editControllerList: [],
                    delControllerList: []
                };
                var oldControllerIdList = [];//旧的实控人id列表
                var newControllerIdList = [];//提交时实控人id列表
                if (Model.isControllerChanged) {
                    if (Model.controllerListOld.length == 0 && Model.controllerList.length > 0) {//旧的实控人信息为空，提交时实控人信息不为空，此时存放在add里
                        controllerInfo.addControllerList = Model.controllerList
                    } else if (Model.controllerListOld.length > 0 && Model.controllerList.length == 0) {//当提交信息里没有实控人信息，旧的有值，此时记录被删除的实控人id
                        Model.controllerListOld.forEach(function (item) {
                            controllerInfo.delControllerList.push(JSON.parse(item).idStr.toString())
                        })
                    } else {
                        angular.forEach(Model.controllerList,function (newItem) {
                            if (!newItem.idStr) {
                                //提交时当实控人信息没有id证明是新增实控人
                                controllerInfo.addControllerList.push(newItem)
                            }
                        })
                        Model.controllerListOld.forEach(function (oldItem) {
                            oldControllerIdList.push(JSON.parse(oldItem).idStr);
                            angular.forEach(Model.controllerList,function (itemInfo) {
                                if (itemInfo.idStr) {
                                    newControllerIdList.push(itemInfo.idStr)
                                }
                                if (JSON.parse(oldItem).idStr == itemInfo.idStr && oldItem != JSON.stringify(itemInfo)) {//判断当id相等时实控人信息有没有改变
                                    itemInfo.ctfEffectiveDate = $filter('date')($filter('date')(itemInfo.ctfEffectiveDate, "yyyy-MM-dd"), "yyyy-MM-dd");
                                    itemInfo.ctfExpireDate = $filter('date')($filter('date')(itemInfo.ctfExpireDate, "yyyy-MM-dd"), "yyyy-MM-dd");
                                    itemInfo.id = itemInfo.idStr;
                                    controllerInfo.editControllerList.push(itemInfo);
                                }
                            })
                        });
                        newControllerIdList = AUI.BaseJSUtil.unique(newControllerIdList);
                        oldControllerIdList.forEach(function (itemId) {
                            if (newControllerIdList.indexOf(itemId) < 0) {//当旧的实控人信息id在新的实控人id列表找不到，证明被删掉了
                                controllerInfo.delControllerList.push(itemId.toString())
                            }
                        })
                    }
                }
                if (controllerInfo.addControllerList.length == 0) {
                    delete controllerInfo.addControllerList
                }
                if (controllerInfo.editControllerList == 0) {
                    delete controllerInfo.editControllerList
                }
                if (controllerInfo.delControllerList == 0) {
                    delete controllerInfo.delControllerList
                }


                // 拼装请求参数
                var jsonStr = {
                    developerMerchantInfo: {
                        contactList: contactList,
                        developerBanks: []
                    },
                    merchantTaxInfo: userTaxInfo,
                    controllerInfo: controllerInfo
                };

                // 证件信息
                if(Model.identityInfo && (Model.identityInfoFlag || (Model.isCheckedBankCN && $scope.isBankCNChanged))) {
                    if(Model.userInfo.userType === 1) {
                        jsonStr['developerAttachment'] = {
                            attachment1: Model.perCtfFg,
                            attachment2: Model.perCtfBg
                        }
                    }else {
                        jsonStr['developerAttachment'] = {
                            attachment10: Model.contactorImg10,
                            attachment4: Model.corpEntityPicFile,
                            attachment5: Model.corpEntityPicFile1
                        }
                    }
                }

                var operationFirstFlag = false

                // 场景信息
                if(Model.operationInfoFlag && Model.chooseSceneList.length > 0 && (Model.operationHasChange || (Model.userInfo.verifyBankState !== 2 && $scope.isBankCNChanged))) {
                    if(Model.myUserInfo.verifyBankState !== 2) {
                        operationFirstFlag = true
                    }
                    jsonStr['merchantBusinessInfo'] = {}
                    for(var j = 0; j < Model.chooseSceneList.length; j ++) {
                       if(j === 0){
                            jsonStr['merchantBusinessInfo']['businessScene'] = Model.chooseSceneList[j] + '|'
                        }else {
                            jsonStr['merchantBusinessInfo']['businessScene'] = jsonStr['merchantBusinessInfo']['businessScene'] + Model.chooseSceneList[j] + '|'
                        }
                    }
                    jsonStr['merchantBusinessInfo']['businessScene'] = jsonStr['merchantBusinessInfo']['businessScene'].slice(0,jsonStr['merchantBusinessInfo']['businessScene'].length-1)
                    for(var i = 0 ; i< Model.sceneList.length; i++) {
                        if(Model.sceneList[i].label === 'APP' && Model.sceneList[i].isChecked) {
                            jsonStr['merchantBusinessInfo']['appDownloadUrl'] = Model.operationInfo.appDownloadUrl
                            jsonStr['merchantBusinessInfo']['appId'] = Model.operationInfo.appId
                            jsonStr['merchantBusinessInfo']['appScreenshot'] = Model.printScreen
                        }
                        if(Model.sceneList[i].label === 'PC网站' && Model.sceneList[i].isChecked) {
                            jsonStr['merchantBusinessInfo']['website'] = Model.operationInfo.website
                            jsonStr['merchantBusinessInfo']['icp'] = Model.operationInfo.Icp
                        }
                        if(Model.sceneList[i].label === '其他' && Model.sceneList[i].isChecked) {
                            jsonStr['merchantBusinessInfo']['productShowcase'] = Model.productShowcase
                        }
                    }
                    jsonStr['merchantBusinessInfo']['categoryCode'] = Model.categoryCode.value
                    jsonStr['merchantBusinessInfo']['subCategoryCode'] = Model.subCategoryCode.value
                }
                if(userType != 2) delete jsonStr.controllerInfo;
                if (Model.isCheckedBankCN && ($scope.isBankCNChanged || Model.isReVer || Model.identityInfoFlag || operationFirstFlag)) {
                    jsonStr.developerMerchantInfo.developerBanks.push({
                        bankName: Model.bankInfoCN.bank.value,
                        bankAcctName: Model.bankInfoCN.accountName,
                        bankAccount: (Model.bankInfoCN.bankAccount == Model.bankInfoCN.bankAccountFuzzy) ? oldBankInfoCN.bankAccount : Model.bankInfoCN.bankAccount,
                        hProvince: Model.bankInfoCN.province.value,
                        hCity: Model.bankInfoCN.city.value,
                        hAddr: Model.bankInfoCN.branch.value,
                        country: Model.bankInfoCN.country.key,
                        currency: 'CNY',
                        bankType: 0,
                        branchNumber: String(Model.bankInfoCN.branchNumber),
                        swiftCode: Model.bankInfoCN.swiftCode || '',
                        bankAttachment: '',
                        acctNameAttachment: Model.acctNameAttachmentCN
                    });
                    if (Model.bankInfoCN.legalManVideoUrl) {
                        jsonStr.developerMerchantInfo.developerBanks[0].legalManVideoUrl = Model.bankInfoCN.legalManVideoUrl;
                    }
                }
                if (Model.isCheckedBankEN && ($scope.isBankENChanged || Model.isReVer)) {
                    //在岸
                    var isOffsite = Model.bankInfoEN.country.key != 'CN';
                    if (!isOffsite) {
                        jsonStr.developerMerchantInfo.developerBanks.push({
                            bankName: Model.bankInfoEN.bank.value,
                            bankAcctName: Model.bankInfoEN.accountName,
                            bankAccount: (Model.bankInfoEN.bankAccount == Model.bankInfoEN.bankAccountFuzzy) ? oldBankInfoEN.bankAccount : (Model.bankInfoEN.bankAccount || ''),
                            hAddr: Model.bankInfoEN.branch.value || '',
                            country: Model.bankInfoEN.country.key,
                            currency: Model.bankInfoEN.currency,
                            bankType: 1,
                            branchNumber: String(Model.bankInfoEN.branchNumber || ''),
                            swiftCode: Model.bankInfoEN.swiftCode || '',
                            bankAttachment: '',
                            acctNameAttachment: Model.acctNameAttachmentEN
                        });
                    }
                    //离岸
                    else {
                        var offSiteBank = {
                            country: Model.bankInfoEN.country.key,
                            bankName: Model.bankInfoEN.bank.value,
                            hAddr: Model.bankInfoEN.branch.value || '',
                            currency: Model.bankInfoEN.currency,
                            bankAttachment: '',
                            bankType: 1,
                            acctNameAttachment: Model.acctNameAttachmentEN
                        };
                        var existAttr = function (attr) {
                            return $scope.selectCountryCfg && $scope.selectCountryCfg[attr] && $scope.selectCountryCfg[attr]['showFlag'];
                        };
                        existAttr('swiftCode') && (offSiteBank.swiftCode = Model.bankInfoEN.swiftCode);
                        existAttr('accountNumber') && (offSiteBank.bankAccount = (Model.bankInfoEN.bankAccount == Model.bankInfoEN.bankAccountFuzzy) ? oldBankInfoEN.bankAccount : Model.bankInfoEN.bankAccount);
                        existAttr('accountName') && (offSiteBank.bankAcctName = Model.bankInfoEN.accountName);
                        existAttr('kc') && (offSiteBank.kc = Model.bankInfoEN.kc || '');
                        existAttr('accountType') && (offSiteBank.accountType = Model.bankInfoEN.accountType || 'SAVINGS');
                        existAttr('taxPayerID') && (offSiteBank.taxPayerId = Model.bankInfoEN.taxPayerId || '');
                        //新增3个字段
                        existAttr('city') && (offSiteBank.hCity = Model.bankInfoEN.hCity || '');
                        existAttr('branchAddress') && (offSiteBank.branchAddress = Model.bankInfoEN.branchAddress || '');
                        existAttr('attribute4') && (offSiteBank.attribute4 = Model.bankInfoEN.attribute4 || '');
                        Model.bankInfoEN.iban && existAttr('iban') && (offSiteBank.iban = Model.bankInfoEN.iban ? (Model.bankInfoEN.country.key + Model.bankInfoEN.iban) : "");
                        Model.bankInfoEN.branchNumber && existAttr('branchNumber') && (offSiteBank.branchNumber = Model.bankInfoEN.branchNumber ? Model.bankInfoEN.branchNumber : "");
                        Model.bankInfoEN.bankNumber && existAttr('bankNumber') && (offSiteBank.bankNumber = Model.bankInfoEN.bankNumber ? Model.bankInfoEN.bankNumber : "");
                        jsonStr.developerMerchantInfo.developerBanks.push(offSiteBank);
                    }
                }

                if (!Model.isControllerChanged && !Model.isReVer) {
                    delete jsonStr.controllerInfo
                }

                if (!$scope.isContractorChanged && !Model.isReVer) {
                    delete jsonStr.developerMerchantInfo.contactList
                }
                if (!$scope.isTaxChanged && !Model.isReVer) {
                    delete jsonStr.merchantTaxInfo
                }
                if (!$scope.isBankCNChanged && !Model.isReVer && !Model.identityInfoFlag) {
                    delete jsonStr.developerMerchantInfo.developerBanks.developerBankCN;
                }

                if (!$scope.isBankENChanged && !Model.isReVer) {
                    delete jsonStr.developerMerchantInfo.developerBanks.developerBankEN;
                }

                if (!$scope.isContractorChanged && !$scope.isBankCNChanged && !$scope.isBankENChanged && !Model.isReVer && !Model.identityInfoFlag && !operationFirstFlag) {
                    delete jsonStr.developerMerchantInfo
                }
                return jsonStr;
            }


            function bankBranchENOut(branchAutoVal, Model, $scope) {
                bankBranchOut(branchAutoVal, Model, Model.branchsEN, 'bankInfoEN', 'bankENBranch', true, $scope);
            }

            function bankBranchCNOut(branchAutoVal, Model, $scope) {
                bankBranchOut(branchAutoVal, Model, Model.branchs, 'bankInfoCN', 'bankCNBranch', false, $scope);
            }

            function bankBranchOut(branchAutoVal, Model, banks, bankinfo, form, isShowSwiftCode, $scope) {
                if (branchAutoVal) {
                    branchAutoVal = branchAutoVal.trim();
                    var branchs = banks;
                    var len = branchs.length;
                    //找到输入的中文支行
                    var found = false;
                    for (var i = 0; i < len; i++) {
                        if (branchs[i].key === branchAutoVal) {
                            found = true;
                            return;
                        }
                    }
                    if (!found && Model.bankInfoCN.branch) {
                        Model[bankinfo].branch.key = '';
                        Model[bankinfo].branch.value = '';
                        $scope.bankInfoForm[form].$dirty = true;
                        // 有提示错误时，将开户行号置为空
                        Model[bankinfo].branchNumber = '';
                        if (isShowSwiftCode) {
                            Model[bankinfo].swiftCode = '';
                        }
                    }
                } else {
                    if (Model[bankinfo].branch) {
                        Model[bankinfo].branch.key = '';
                        Model[bankinfo].branch.value = '';
                        $scope.bankInfoForm[form].$dirty = true;
                    }
                    // autocomplete支行没有值，将开户行号置为空
                    Model[bankinfo].branchNumber = '';
                    if (isShowSwiftCode) {
                        Model[bankinfo].swiftCode = '';
                    }
                }
            }

            function setBankForBussiness(branch, Model, isCN, $scope) {
                var suffix = isCN ? "CN" : "EN";
                if (Model['bankInfo' + suffix].country && Model['bankInfo' + suffix].country.key == 'CN') {
                    Model['bankInfo' + suffix].hProvince = branch.province;
                    Model['bankInfo' + suffix].hCity = branch.city;
                    Model['bankInfo' + suffix].hAddr = branch.branchName;
                    Model['bankInfo' + suffix].bank = {key: branch.bankName, value: branch.bankName};
                    $scope.$broadcast('huaweicomplete-alt:changeInput', 'backAuto' + suffix, Model['bankInfo' + suffix].bank); //设置控件值
                    Model['bankInfo' + suffix].province = {
                        key: branch.province,
                        value: branch.province
                    };
                    Model['bankInfo' + suffix].city = {key: branch.city, value: branch.city};
                    Model['bankInfo' + suffix].branch = {
                        key: branch.branchName,
                        value: branch.branchName
                    };
                    $scope.$broadcast('huaweicomplete-alt:changeInput', 'branchAuto' + suffix, Model['bankInfo' + suffix].branch); //设置控件值
                    Model['bankInfo' + suffix].branchNumber = branch.branchNumber;
                    Model['bankInfo' + suffix].branch.branchNumber = branch.branchNumber
                    Model['bankInfo' + suffix].swiftCode = branch.swiftCode;
                    !isCN && (Model['bankInfo' + suffix].branch.swiftCode = branch.swiftCode);
                }
                //离岸银行
                else if (Model['bankInfo' + suffix].country && Model['bankInfo' + suffix].country.key != 'CN') {
                    Model.bankInfoEN.hAddr = branch.branchName;
                    Model.bankInfoEN.bank = {
                        key: branch.bankName,
                        value: branch.bankName,
                        bankNumber: branch.bankNumber
                    };
                    Model.bankInfoEN.bankName = branch.bankName;
                    Model.bankInfoEN.bankNumber = branch.bankNumber;
                    $scope.bankInfoForm.bankEN.$setDirty(true);
                    Model.bankInfoEN.branch = {
                        key: branch.branchName,
                        value: branch.branchName,
                        branchNumber: branch.branchNumber,
                        swiftCode: branch.swiftCode,
                        bankNumber: branch.bankNumber,
                        kc: branch.kc
                    };
                    Model.bankInfoEN.branchNumber = branch.branchNumber;
                    Model.bankInfoEN.swiftCode = branch.swiftCode;
                    Model.bankInfoEN.kc = branch.kc;
                    Model.isKcDisabled =  !!Model.bankInfoEN.kc;
                    $scope.bankInfoForm.swiftCodeEN.$setDirty(true);
                    //支行下拉列表显示所有的支行
                    Model.branchsEN = tenantsService.convertBranchs(Model.branchsEN, branch.branchs);
                    $scope.bankInfoForm.bankENBranch.$setDirty(true);
                    $scope.$broadcast('huaweicomplete-alt:changeInput', 'backAuto' + suffix, branch.bankName); //设置控件值
                    $scope.$broadcast('huaweicomplete-alt:changeInput', 'branchAuto' + suffix, branch.branchName); //设置控件值
                }
            }

            //获取字段的值，如果是常量直接disable返回常量，如果是字符串不符合则给修改
            function getFieldValueForCfg(field, value, $scope) {
                var rs = value;
                var cfg = $scope.selectCountryCfg;
                cfg && cfg[field] && (cfg[field].attrType == 'S') && (cfg[field].disabled = (new RegExp(cfg[field].pattern).test(rs)));
                cfg && cfg[field] && (cfg[field].attrType == 'C') && (cfg[field].disabled = true, rs = cfg[field].value);
                return rs;
            }

            //iban特殊处理,去掉2位国家简码
            function getIban4InitForBuss(bankInfo, Model) {
                if (bankInfo && bankInfo.iban && bankInfo.iban.length >= 2 && bankInfo.country.key != 'CN') {
                    Model.bankInfoEN.iban = bankInfo.iban.substring(2);
                } else {
                    Model.bankInfoEN.iban = bankInfo.iban;
                }
                bankInfo.ibanConfirm = bankInfo.iban;
            }

            //校验币种
            function validCurrency(Model) {
                var flag = true;
                if (Model.accountCurrency.selectCurrencys && Model.accountCurrency.selectCurrencys.length > 0) {
                    flag = true;
                    Model.accountCurrency.showAccountErrorMsg = false;
                } else {
                    Model.accountCurrency.showAccountErrorMsg = true;
                    return false;
                }
                if (Model.bankInfoEN.currencyObj && Model.bankInfoEN.currencyObj.key) {
                    flag = true;
                    Model.accountCurrency.showDefualErrorMsg = false;
                } else {
                    Model.accountCurrency.showDefualErrorMsg = true;
                    return false;
                }
                return flag
            }

            function setTaxData(developerInfo, userTaxInfo, Model, taxType) {
                // mod by at 1.7.1 for 银行信息配置优化   begin
                Model.taxInfo.realName = developerInfo.realName;
                Model.taxInfo.registerAddress = (userTaxInfo && userTaxInfo.registerAddress) || Model.incorDeveloper.corpAddress || Model.incorDeveloper.indivAddress;

                /**
                 *  如果已经有省市信息，要根据填写的省市（包括城市）和实名认证的信息作对比
                 *  1.如果二者相同，则默认选中实名认证中的省市和城市
                 *  2.如果二者不一样，则将Model.taxInfo.province/taxCity设置成空，有用户手动选择
                 */
                if (Model.userTaxInfoOld && Model.userTaxInfoOld.taxProvinceName) {
                    // 税务信息中的省市信息和实名认证的省市信息不一样，则将Model.taxInfo.province设成空，有用户自己选择
                    if (!Model.isAudting && (Model.userTaxInfoOld.taxProvinceName != Model.incorDeveloper.provinceName)) {
                        Model.taxInfo.province = {};
                    } else {
                        Model.taxInfo.province = {
                            key: userTaxInfo.taxProvinceName,
                            value: userTaxInfo.taxProvince
                        };
                    }
                    // 税务信息中的城市信息和实名认证的城市信息不一样，则将Model.taxInfo.city设成空，有用户自己选择
                    if (!Model.isAudting && (Model.userTaxInfoOld.taxCityName != Model.incorDeveloper.cityName)) {
                        Model.taxInfo.city = {};
                    } else {
                        Model.taxInfo.city = {
                            key: userTaxInfo.taxCityName,
                            value: userTaxInfo.taxCity
                        };
                    }

                    Model.taxInfo.taxReceiptType = userTaxInfo.taxReceiptType ? {
                        key: userTaxInfo.taxReceiptType,
                        value: systemParaConf.taxReceiptType[userTaxInfo.taxReceiptType]
                    } : {key: '', value: ''};
                    Model.taxInfo.taxNum = userTaxInfo.taxNum;
                    Model.taxInfo.taxType = (developerInfo.userType ? developerInfo.userType : Model.userType) - 1;
                    Model.taxInfo.typeDesc = taxType[Model.taxInfo.taxType];
                } else {
                    Model.taxInfo.taxType = (developerInfo.userType ? developerInfo.userType : Model.userType) - 1;
                    Model.taxInfo.typeDesc = taxType[Model.taxInfo.taxType];
                    Model.taxInfo.province = {
                        key: Model.incorDeveloper.provinceName,
                        value: Model.incorDeveloper.corpProvince || Model.incorDeveloper.perProvince
                    };
                    Model.userTaxInfoOld.taxProvinceName = Model.incorDeveloper.provinceName;
                    Model.taxInfo.city = {
                        key: Model.incorDeveloper.cityName,
                        value: Model.incorDeveloper.corpCity || Model.incorDeveloper.perCity
                    };
                    Model.userTaxInfoOld.taxCityName = Model.incorDeveloper.cityName;
                }
            }

            //获取税务类型
            function getTaxReceiptTypes(Model) {
                var taxReceiptTypes = [];
                if (Model.taxInfo.taxType == 1 || (!Model.taxInfo.taxType && Model.userType == 2)) {
                    for (var i in systemParaConf.taxReceiptTypeCorp) {
                        taxReceiptTypes.push({key: i, value: systemParaConf.taxReceiptTypeCorp[i]});
                    }
                } else {
                    for (var j in systemParaConf.taxReceiptTypePer) {
                        taxReceiptTypes.push({key: j, value: systemParaConf.taxReceiptTypePer[j]});
                    }
                }
                return taxReceiptTypes;
            }
            //获取加拿大税务信息
            function getMerchantTaxInfo(Model){
                var defer = $q.defer();
                OpenUp.getMerchantTaxInfo({
                    req: {}
                }).then(function (taxInfo){
                    Model.otherTaxsIncluded = taxInfo.merchantTaxInfo.otherTaxsIncluded?taxInfo.merchantTaxInfo.otherTaxsIncluded:0;
                    Model.defaultOtherTaxsIncluded = taxInfo.merchantTaxInfo.otherTaxsIncluded?taxInfo.merchantTaxInfo.otherTaxsIncluded:0;
                    taxInfo.merchantTaxInfo.deliveryCountryTaxItems[0].taxItems.forEach(function (item){
                        if(item.taxClassCode == 'NA'){
                            Model.newTaxItem[Model.newTaxItem.length - 1].taxNum= item.taxNumber;
                            Model.TaxItem[Model.TaxItem.length - 1].termsIsSelected = true;
                            Model.TaxItem[Model.TaxItem.length - 1].disabled = false;
                        }else {
                            Model.newTaxItem[item.taxClassCode[item.taxClassCode.length - 1] - 1].taxNum= item.taxNumber;
                            Model.TaxItem[item.taxClassCode[item.taxClassCode.length - 1] - 1].termsIsSelected = true;
                            Model.TaxItem[item.taxClassCode[item.taxClassCode.length - 1] - 1].disabled = false
                        }

                    });
                }).catch(function () {
                    defer.resolve();
                })
                return defer.promise;
            }

            function changeCurrencyEn(Model, curr) {
                Model.defaultCountrys = [];
                Model.defaultCountrysList.forEach(function (val) {
                    Model.defaultCountrys.push(val.value)
                });
                Model.accountErrorMsg = !((Model.bankInfoEN.currency && Model.defaultCountrys.indexOf(Model.bankInfoEN.currency) != -1) || (curr && Model.defaultCountrys.indexOf(curr) != -1));
                Model.accountCurrency.showDefualErrorMsg = !curr;
                if (!Model.isAudting) {
                    Model.bankInfoEN.currency = curr;
                }
            }

            //设置服务状态,以及提示信息
            function setTipMsg(bussinessInfo, Model) {
                //0未银行信息(草稿)；,1待审核,2 审核通过,3 审核未通过
                var bkCN = bussinessInfo.bankInfoCN;
                var bkEN = bussinessInfo.bankInfoEN;
                if (bkCN && bkCN.verifyBankState == '2' || bkEN && bkEN.verifyBankState == '2') {
                    Model.serviceStateMsg = Model.serviceStateMsg = mainCons.modUserinfoConstant.bussinessState[2];
                } else if (bkCN && bkCN.verifyBankState == '1' || bkEN && bkEN.verifyBankState == '1') {
                    Model.serviceStateMsg = Model.serviceStateMsg = mainCons.modUserinfoConstant.bussinessState[1];
                } else {
                    Model.serviceStateMsg = Model.serviceStateMsg = mainCons.modUserinfoConstant.bussinessState[0];
                }
            }

            function auiDrawImage(attachment, whDist, $scope, Model) {
                AUI.HTMLUtil.drawImage(180, 120, attachment, function (wh) {
                    $scope.$apply(function () {
                        Model[whDist] = wh;
                    });
                });
            }

            function validBankParamForBuss(oldUserInfo, Model) {
                var flag = true;
                //开户银行和真实姓名要保持一致  忽略开发者名称中的书名号
                var name = oldUserInfo.realName;
                var accountNameWithoutBooktitle = (name.replace(/《/g, "")).replace(/》/g, "");
                if (Model.bankInfoCN.accountName != accountNameWithoutBooktitle && Model.bankInfoCN.accountName != name && Model.bankInfoCN.updateBankState != 1 && Model.bankInfoCN.verifyBankState != 1) {
                    flag = false;
                    var msg = '开户名须与公司名称一致';
                    if (oldUserInfo.userType == 1) {
                        msg = '开户名须与真实姓名一致';
                    }
                    Model.valid.accountNameCNValid = {isValidSuc: false, isShowValid: true, validMsg: msg};
                } else {
                    Model.valid.accountNameCNValid = {isValidSuc: true, isShowValid: false};
                }
                return flag;
            }
            //针对香港的国家做的AccountNumber的检查
            function checkHKAccountNumber(Model) {
                var defer = $q.defer();
                if (Model.checkHKAccountNumberEN && Model.bankInfoEN && Model.bankInfoEN.country && Model.bankInfoEN.country.key == 'HK') {
                    OpenUp.checkBranchCode({
                        req: {
                            bankCode: Model.bankInfoEN.bankNumber,
                            branchAccount: (Model.bankInfoEN.bankAccount == Model.bankInfoEN.bankAccountFuzzy)? Model.bankInfoEN.bankAccountOld:Model.bankInfoEN.bankAccount
                        }
                    }).then(function (data) {
                        if (data && data.isMatch == 0) {
                            auiDialog.confirm("开户行帐号提示","Bank account number（开户行帐号）需包含Branch code（支行号），请使用Branch code（支行号） + Bank account number（开户行帐号）作为完整账户，否则存在无法收款的风险，是否继续提交？",function (){
                                defer.resolve();
                            },function (){
                                defer.reject();
                            })
                        } else {
                            defer.resolve();
                        }
                    }).catch(function () {
                        defer.resolve();
                    })
                } else {
                    defer.resolve();
                }
                return defer.promise;
            }

            return {
                'getBussinesInfo': getBussinesInfo,
                'getBussinesInfoMsg': getBussinesInfoMsg,
                'getNotifyMessage': getNotifyMessage,
                'getMerchantInfo': getMerchantInfo,
                'getPayVerifyBank': getPayVerifyBank,
                'getExtAttr': getExtAttr,
                'getMerchantCountryList': getMerchantCountryList,
                'getCurrencyConfig': getCurrencyConfig,
                'getIsSignAgreement': getIsSignAgreement,
                'signSingleAgreement': signSingleAgreement,
                'changeContract': changeContract,
                'changeTax': changeTax,
                'changeBankInfoOffSite': changeBankInfoOffSite,
                'changeBankInfoEN': changeBankInfoEN,
                'changeBankInfoCN': changeBankInfoCN,
                'getDefaultCountrysList': getDefaultCountrysList,
                'initSetContactInfo': initSetContactInfo,
                'beforeSubmitBankInfo': beforeSubmitBankInfo,
                'bankBranchENOut': bankBranchENOut,
                'bankBranchCNOut': bankBranchCNOut,
                'setBankForBussiness': setBankForBussiness,
                'getFieldValueForCfg': getFieldValueForCfg,
                'getIban4InitForBuss': getIban4InitForBuss,
                'validCurrency': validCurrency,
                'setTaxData': setTaxData,
                'getTaxReceiptTypes': getTaxReceiptTypes,
                'changeCurrencyEn': changeCurrencyEn,
                'setTipMsg': setTipMsg,
                'auiDrawImage': auiDrawImage,
                'validBankParamForBuss': validBankParamForBuss,
                checkHKAccountNumber: checkHKAccountNumber,
                'getMerchantTaxInfo':getMerchantTaxInfo

            }
        }]);
});

